export const createLogger = (prefix) => ({
    info: (...args) => console.log(prefix, ...args),
    debug: (...args) => console.log(prefix, ...args),
    error: (...args) => console.error(prefix, ...args),
});
//# sourceMappingURL=createLogger.js.map